import { useNavigate } from "react-router-dom";
import "../../assests/css/customer/NotFound/NotFound.css";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="nf-page">

      {/* Floating shapes */}
      <div className="nf-shape s1" />
      <div className="nf-shape s2" />
      <div className="nf-shape s3" />
      <div className="nf-shape s4" />
      <div className="nf-shape s5" />
      <div className="nf-cross" style={{ top: "15%", right: "22%" }}>×</div>
      <div className="nf-cross" style={{ bottom: "22%", left: "18%" }}>×</div>

      {/* LEFT — Cart Illustration */}
      <div className="nf-left">
        <div className="nf-circle-bg" />
        <svg viewBox="0 0 260 260" width="260" height="260" className="nf-svg">

          {/* Bag 1 */}
          <rect x="70" y="90" width="44" height="54" rx="5" fill="#AD8B73"/>
          <rect x="82" y="82" width="20" height="16" rx="10" fill="none" stroke="#AD8B73" strokeWidth="4"/>
          <rect x="73" y="108" width="38" height="3" rx="1.5" fill="#9a7a64" opacity="0.5"/>

          {/* Bag 2 */}
          <rect x="106" y="75" width="48" height="68" rx="5" fill="#7a5e48"/>
          <rect x="118" y="65" width="24" height="18" rx="12" fill="none" stroke="#7a5e48" strokeWidth="4"/>
          <rect x="109" y="110" width="42" height="3" rx="1.5" fill="#6b5040" opacity="0.5"/>

          {/* Bag 3 */}
          <rect x="148" y="88" width="42" height="56" rx="5" fill="#E3CAA5"/>
          <rect x="159" y="79" width="20" height="16" rx="10" fill="none" stroke="#E3CAA5" strokeWidth="4"/>
          <rect x="150" y="108" width="38" height="3" rx="1.5" fill="#c9b08a" opacity="0.5"/>

          {/* Cart body */}
          <path d="M55 158 L58 158 L72 205 L198 205 L210 165 L65 158 Z" fill="#AD8B73"/>
          <circle cx="100" cy="175" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="120" cy="175" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="140" cy="175" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="160" cy="175" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="180" cy="175" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="107" cy="188" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="127" cy="188" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="147" cy="188" r="3" fill="#fff" opacity="0.6"/>
          <circle cx="167" cy="188" r="3" fill="#fff" opacity="0.6"/>

          {/* Handle */}
          <line x1="48" y1="158" x2="58" y2="158" stroke="#7a5e48" strokeWidth="5" strokeLinecap="round"/>
          <line x1="38" y1="145" x2="50" y2="158" stroke="#7a5e48" strokeWidth="5" strokeLinecap="round"/>

          {/* Wheels */}
          <circle cx="100" cy="215" r="13" fill="#7a5e48"/>
          <circle cx="100" cy="215" r="7" fill="#E3CAA5"/>
          <circle cx="183" cy="215" r="13" fill="#7a5e48"/>
          <circle cx="183" cy="215" r="7" fill="#E3CAA5"/>

          {/* Decorations */}
          <circle cx="45" cy="110" r="4" fill="#E3CAA5" opacity="0.6"/>
          <circle cx="218" cy="130" r="5" fill="#AD8B73" opacity="0.4"/>
          <polygon points="228,90 232,100 222,100" fill="#E3CAA5" opacity="0.5"/>
        </svg>
      </div>

      {/* RIGHT — Text */}
      <div className="nf-right">
        <div className="nf-code">4<span>0</span>4</div>
        <h1 className="nf-headline">Page Not Found</h1>
       
        <button className="nf-btn-primary" onClick={() => navigate("/")}>
          🏠 Go to Home
        </button>
        <button className="nf-btn-ghost" onClick={() => navigate("/")}>
            🛍️ Browse Collections
        </button>
      </div>

    </div>
  );
}